/*
 *
 * NotificationsList constants
 *
 */

export const LOAD_DATA = 'claris-vnext/NotificationsList/LOAD_DATA';
export const LOAD_DATA_SUCCESS = 'claris-vnext/NotificationsList/LOAD_DATA_SUCCESS';
export const LOAD_DATA_ERROR = 'claris-vnext/NotificationsList/LOAD_DATA_ERROR';
